import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_NODE_SERVER_URL || 'http://localhost:5000/api',
});

const ai = axios.create({
  baseURL: process.env.REACT_APP_PYTHON_SERVER_URL || 'http://localhost:8080/',
});

export { api, ai };
export default api;